import { type FC, useEffect, useState } from 'react';
import useQuoteProductDimUomList from '@redux/hooks/useQuoteProductDimUomList';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import FormSelectBox from '../Inputs/FormSelectBox';

interface QuoteProductDimentionsUomSelectorProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  onChange?: (value: unknown) => void;
  tabIndex?: number;
  margin?: string;
  isRequired?: boolean;
}

const QuoteProductDimentionsUomSelector: FC<QuoteProductDimentionsUomSelectorProps> = ({
  placeholder = i18n.t('translation:default.fields.unitOfMeasurement.placeholder'),
  label = i18n.t('translation:default.fields.unitOfMeasurement.label'),
  rules = [],
  name,
  editMode,
  onChange,
  tabIndex,
  margin = 'mb-0',
  isRequired = false,
}) => {
  const [options, setOptions] = useState<{ label: string; value: string }[] | []>([]);
  const dimList = useQuoteProductDimUomList();

  useEffect(() => {
    if (dimList?.length >= 0) {
      const options = dimList?.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [dimList]);

  return (
    <FormSelectBox
      loading={dimList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      isRequired={isRequired}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tabIndex={tabIndex}
      dataTestId="product-details-dimentions-uom-selector"
    />
  );
};

export default QuoteProductDimentionsUomSelector;
